import { render } from "./ResumeTemplateDraw.vue?vue&type=template&id=3fcb5f39&scoped=true"
import script from "./ResumeTemplateDraw.vue?vue&type=script&lang=js"
export * from "./ResumeTemplateDraw.vue?vue&type=script&lang=js"

import "./ResumeTemplateDraw.vue?vue&type=style&index=0&id=3fcb5f39&scoped=true&lang=less"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-3fcb5f39"]])

export default __exports__